export default __webpack_public_path__ + "static/pluggable-discovery-state-machine-7d1c65ef16c9e7eda396be7a78a62913.png";